<template>
  <v-container fluid>
    <div class="modal-padding share">
      <v-row>
        <v-col cols="12" sm="12" class="left--right-00">
          <div class="Schedule-block">
            <div class="Schedule-left">
              <div class="Schedule-title">Share Test</div>
              <v-row>
                <v-col cols="12" sm="12">
                  <div class="info-row">
                    <div class="label-data">Test Name:</div>
                    <div class="lable-input">
                      <v-text-field
                        v-model="testName"
                        dense
                        hide-details
                        :disabled="disableStartDateTime"
                      ></v-text-field>
                    </div>
                  </div>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12" sm="12">
                  <div class="info-row">
                    <div class="label-data">Test Duration:</div>
                    <div class="lable-input">
                      {{ testDuration + " Min" }}
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row class="date-row-share">
                <!-- unlock download  --><v-col cols="12" sm="12" class="pt-0 pb-0">
                <div class="info-row">
                  <div class="label-data">Unlock Test Download:</div>
                  <div class="lable-input date-pick" :class="{'start-date-disable': disableStartDate}">
                    <v-menu
                      :disabled="disableunlockTime"
                      ref="unlockTestDateMenu"
                      v-model="unlockTestDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="unlockDate"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="130px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedDateFormattedMomentjs(unlockDate)"
                          @click="disableClick('Unlock')"
                          label="Date"
                          append-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="unlockDate"
                        @input="$refs.unlockTestDateMenu.save(unlockDate)"
                        :allowed-dates="allowedDates"
                        :max="allowed_end_date"
                        scrollable
                      >
                        <v-alert dense outlined type="info">Subscription-expiry: {{ allowed_end_date }}</v-alert>
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div class="hr-min-block" :class="{'start-date-disable': disableStartDateTime}">
                    <v-menu
                      :disabled="disableStartDateTime"
                      ref="unlockTestTimeMenu"
                      v-model="unlockTestTimeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="unlockTime"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="250px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="unlockTime"
                          label="Time"
                          @click="disableClick('unlockTime')"
                          append-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="unlockTestTimeMenu"
                        v-model="unlockTime"
                        @click:minute="$refs.unlockTestTimeMenu.save(unlockTime)"
                        full-width
                        format="24hr"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>

              <!-- Schedule Start -->
              <v-col cols="12" sm="12" class="pt-0 pb-0">
                <div class="info-row">
                  <div class="label-data">Schedule Start:</div>
                  <div class="lable-input date-pick" :class="{'start-date-disable': disableStartDate}">
                    <v-menu
                      :disabled="disableStartDateTime"
                      ref="startDateMenu"
                      v-model="startDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="startDate"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="130px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedDateFormattedMomentjs(startDate)"
                          @click="disableClick('StartDate')"
                          label="Date"
                          append-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="startDate"
                        @input="$refs.startDateMenu.save(startDate)"
                        :allowed-dates="allowedDates"
                        :max="allowed_end_date"
                        scrollable
                      >
                        <v-alert dense outlined type="info">Subscription-expiry: {{ allowed_end_date }}</v-alert>
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div class="hr-min-block" :class="{'start-date-disable': disableStartDateTime}">
                    <v-menu
                      :disabled="disableStartDateTime"
                      ref="startTimeMenu"
                      v-model="startTimeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="scheduleTime"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="250px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="scheduleTime"
                          label="Time"
                          append-icon="access_time"
                          readonly
                          @click="disableClick('scheduleTime')"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="startTimeMenu"
                        v-model="scheduleTime"
                        @click:minute="$refs.startTimeMenu.save(scheduleTime)"
                        full-width
                        format="24hr"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>

              <!-- Schedule Close -->
              <v-col cols="12" sm="12" class="pt-0 pb-0">
                <div class="info-row">
                  <div class="label-data">Schedule Close:</div>
                  <div class="lable-input date-pick" :class="{'start-date-disable': disableStartDate}">
                    <v-menu
                      :disabled="disableStartDateTime"
                      ref="scheduleCloseDateMenu"
                      v-model="scheduleCloseDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="scheduleClose"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="130px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedDateFormattedMomentjs(scheduleClose)"
                          @click="disableClick('scheduleClose')"
                          label="Date"
                          append-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="scheduleClose"
                        @input="$refs.scheduleCloseDateMenu.save(scheduleClose)"
                        :allowed-dates="allowedDates"
                        :max="allowed_end_date"
                        scrollable
                      >
                        <v-alert dense outlined type="info">Subscription-expiry: {{ allowed_end_date }}</v-alert>
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div class="hr-min-block" :class="{'start-date-disable': disableStartDateTime}">
                    <v-menu
                      :disabled="disableStartDateTime"
                      ref="scheduleCloseTimeMenu"
                      v-model="scheduleCloseTimeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="scheduleCloseTime"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="250px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="scheduleCloseTime"
                          label="Time"
                          @click="disableClick('scheduleCloseTime')"
                          append-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="scheduleCloseTimeMenu"
                        v-model="scheduleCloseTime"
                        @click:minute="$refs.scheduleCloseTimeMenu.save(scheduleCloseTime)"
                        full-width
                        format="24hr"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>

              <!-- OMR Upload Deadline -->
              <v-col cols="12" sm="12" class="pt-0 pb-0">
                <div class="info-row">
                  <div class="label-data">OMR Upload Deadline:</div>
                  <div class="lable-input date-pick" :class="{'start-date-disable': disableStartDate}">
                    <v-menu
                      :disabled="disableStartDateTime"
                      ref="omrUploadMenu"
                      v-model="omrUploadMenu"
                      :close-on-content-click="false"
                      :return-value.sync="omrUploadDate"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="130px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="computedDateFormattedMomentjs(omrUploadDate)"
                          @click="disableClick('omrUploadDate')"
                          label="Date"
                          append-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="omrUploadDate"
                        @input="$refs.omrUploadMenu.save(omrUploadDate)"
                        :allowed-dates="allowedDates"
                        @change="filterInstitutesByOMRDate" 
                        :max="allowed_end_date"
                        scrollable
                      >
                        <v-alert dense outlined type="info">Subscription-expiry: {{ allowed_end_date }}</v-alert>
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div class="hr-min-block" :class="{'start-date-disable': disableStartDateTime}">
                    <v-menu
                      :disabled="disableStartDateTime"
                      ref="omrUploadTimeMenu"
                      v-model="omrUploadTimeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="omrUploadTime"
                      transition="scale-transition"
                      offset-y
                      top
                      min-width="250px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="omrUploadTime"
                          label="Time"
                          @click="disableClick('omrUploadTime')"
                          append-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="omrUploadTimeMenu"
                        v-model="omrUploadTime"
                        @click:minute="$refs.omrUploadTimeMenu.save(omrUploadTime)"
                        full-width
                        format="24hr"
                      ></v-time-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
              </v-row>
            </div>
            <div class="Schedule-right">
              <div class="intitude-header">
                <div class="Schedule-title d-flex align-center">
                  <span class="font-weight-bold">Select Client Institute:</span>
                  <v-checkbox
                    v-model="isEduracleSelected"
                    @change="validateCheckboxSelection('isEduracleSelected')"
                    label="Eduracle"
                    class="ml-4"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="isWLSelected"
                    @change="validateCheckboxSelection('isWLSelected')"
                    label="WL"
                    class="ml-4"
                  ></v-checkbox>
                </div>
                <div class="select-intitude-share">
                  <v-data-table
                    :items="institutesToDisplay"
                    class="elevation-1"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <template v-slot:headers="{ props }">
                      <tr>
                        <th></th>
                        <th v-for="header in props.headers" :key="header.text" :class="header.class">
                          {{ header.text }}
                        </th>
                      </tr>
                    </template>
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td style="padding: 0;margin: 0;max-height: 24px;">
                            <v-checkbox
                              v-model="selectedIds"
                              :value="item.id"
                              @change="updateSelectedIds"
                            ></v-checkbox>
                          </td>
                          <td style="padding: 0;max-height: 24px;">
                           <div class="d-flex  justify-space-between ">
                             <div class="d-flex flex-column">
                              <strong class="mb-1">{{ item.name }}</strong>
                            <span > {{ item.subdomain }}</span>
                            </div>
                            <div v-if="isExpired(item.expiry_date)" class="d-flex justify-content-end align-end flex-column">
                              <span style="color: red;" class="mb-1">Expires on</span>
                              <span  style="color: red;">
                                {{ formatDate(item.expiry_date) }}
                            </span>
                            </div>
                           </div>                        
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <div>
            <span style="color: green;">Total Selected Institutes:</span> 
            <strong>{{ totalSelected }}</strong>
          </div>
          <div class="right-align">
            <v-btn
            :disabled="totalSelected === 0"
              @click="shareTest"
              class="right-btn cust-btn"
              color="primary"
            >{{isRescheduling || (data && data.selectedTest && data.selectedTest.test_schedule_id) ?'Re-share':'Share'}}</v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- <AlertBox :width="modalwidth" :onClose="onClosePopup" :component="cComponent" :status="openModelStatus" :data="alertBoxData" /> -->
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import constants from "@/utils/constants.js";
import { mapActions, mapState } from "vuex";
export default {
  name: "ShareTest",
  props: ["onClose", "status", "data"],
  data() {
    return {
      reqData: {
      institute_type: [], // Initialize the institute_type array
    },
      selectedInstitute: null, 
      Institute: [],
      isWLSelected: false,
      isEduracleSelected: true,
      unlockDate: null,
      unlockTime: null,
      unlockTestDateMenu: false,
      unlockTestTimeMenu: false,
      startDate: null,
      scheduleTime: null,
      startDateMenu: false,
      startTimeMenu: false,
      scheduleClose: null,
      scheduleCloseTime: null,
      scheduleCloseDateMenu: false,
      scheduleCloseTimeMenu: false,
      omrUploadDate: null,
      omrUploadTime: null,
      omrUploadMenu: false,
      omrUploadTimeMenu: false,
      disableStartDate: false,
      disableStartDateTime: false,
      disableunlockTime: false,
      longTimeTest: false,
      alertBoxData: {},
      modalwidth: "",
      cComponent: "",
      openModelStatus: false,
      isRescheduling: false,
      testName: this.data.selectedTest.test_name,
      testDuration: this.data.selectedTest.duration,
      allowed_end_date: null,
      shuffle: false,
      filteredInstitutes: [], 
      selectedIds: [], 
      previouslySelectedIds: [],
      deSelctedIds: [],
      expiredInstitutesIds: []
    };
  },
  mounted() {
    if (localStorage.getItem("myInstitute")) {
      this.end_date = JSON.parse(localStorage.getItem("myInstitute"));
      this.allowed_end_date = moment(`${this.end_date.expiry_date}`).format("YYYY-MM-DD");
    }
    this.fetchInstitutes();
    if (this.isRescheduling) {
      this.cloneScheduleData();
    }
  },
  methods: {
     ...mapActions({
      getActiveInstituteList: "testStore/getActiveInstituteList",
      share: "testStore/share",
    }),
    resetValues() {
      if (this.data.selectedTest.schedule_id) {
        this.startDate =
          this.data.selectedTest && this.data.selectedTest.scheduled_start
            ? moment(`${this.data.selectedTest.scheduled_start}`).format(
                "YYYY-MM-DD"
              )
            : null;
        this.endDate =
          this.data.selectedTest && this.data.selectedTest.scheduled_end
            ? moment(`${this.data.selectedTest.scheduled_end}`).format(
                "YYYY-MM-DD"
              )
            : null;
        this.startTime =
          this.data.selectedTest && this.data.selectedTest.scheduled_start
            ? moment(`${this.data.selectedTest.scheduled_start}`).format(
                "HH:mm"
              )
            : null;
        this.endTime =
          this.data.selectedTest && this.data.selectedTest.scheduled_end
            ? moment(`${this.data.selectedTest.scheduled_end}`).format("HH:mm")
            : null;
        this.mode = this.data.selectedTest && this.data.selectedTest.visible ? this.data.selectedTest.visible : this.data.isOnlineTest ? null : constants.WINDOW_COMPLETION_VALUE;
        this.shuffle =
          this.data.selectedTest && this.data.selectedTest.shuffle
            ? this.data.selectedTest.shuffle
            : false;
      } else {
        this.startDate = null;
        this.unlockDate = null;
        this.scheduleClose = null;
        this.omrUploadDate = null;
        this.unlockTime = null;
        this.scheduleCloseTime = null;
        this.scheduleTime = null;
        this.omrUploadTime = null;
        this.mode = this.data.isOnlineTest ? null : constants.WINDOW_COMPLETION_VALUE;
        this.shuffle = false;
        
      }
      // this.Institute = null
      this.startDateMenu = false;
      this.endDateMenu = false;
      this.startTimeMenu = false;
      this.endTimeMenu = false;

      this.selectedTest = this.data.selectedTest;
      this.testName = this.data.selectedTest.test_name;
      this.loading = false;
      this.centers = [];
      this.batches = [];
      this.selectedCenter = null;
      this.selectedCenterList = [];
      this.showAddcenterButton = true;
      if(!this.isRescheduling){
        this.longTimeTest=false;
        this.tabChange=false;
      }
    },
    async validateCheckboxSelection(checkbox) {
      if (!this.isEduracleSelected && !this.isWLSelected) {
        alert('At least one option must be selected!');
          await new Promise((res)=>{
              this.$nextTick(() => {
                this.isEduracleSelected = true;
              });
              res();
          })   
      }
      this.fetchInstitutes();
    },
    fetchInstitutes() {
      const instiute_type = {
        is_white_lable : this.isWLSelected,
        is_eduracle : this.isEduracleSelected
      }
      this.getActiveInstituteList(instiute_type)
        .then((data) => {
          if (data && data.length === 0) {
            this.$toasted.error('No active institutes available.', { icon: "error" });
          } else {
            this.Institute = data;
            const selected = this.Institute
              .filter(item => !this.deSelctedIds.includes(item.id))
              .map(item => item.id);
            this.selectedIds = selected;

            const expiredInstitutes = data
              .filter(item => this.isExpired(item.expiry_date))
              .map(item => {
                return {
                  id : item.id,
                  name : item.name
                }
              });
              this.expiredInstitutesIds = expiredInstitutes;
            // if (expiredInstitutes.length > 0) {
            //   this.$toasted.error(`Subscription of the following institutes expire before test completion: ${expiredInstitutes.name}`, { icon: "error", duration: 5000 });
            // }

            this.filterInstitutesByOMRDate();
            this.applyFilters();
          }
        })
        .catch((error) => {
          console.error('Error fetching institutes:', error);
        });
    },
     filterInstitutesByOMRDate() {    
        this.filteredInstitutes = this.Institute;
        const expiredInstitutes = this.filteredInstitutes 
              .filter(item => this.isExpired(item.expiry_date))
              .map(item => {
                return {
                  id : item.id,
                  name : item.name
                }
              });
              

              this.expiredInstitutesIds = expiredInstitutes;
        
        return;
    },

     applyFilters() {
      const whiteLabeled = this.isWLSelected
        ? this.Institute.filter((inst) => inst.is_white_labeled)
        : [];
      const notWhiteLabeled = this.isEduracleSelected
        ? this.Institute
        : [];

      const combinedList = [
        ...whiteLabeled,
        ...notWhiteLabeled.filter(
          (inst) => !whiteLabeled.some((wlInst) => wlInst.id === inst.id)
        )
      ];

      this.filteredInstitutes = [
        ...combinedList,
        ...this.Institute.filter((inst) =>
          this.previouslySelectedIds.includes(inst.id)
        )
      ];

      this.filteredInstitutes = Array.from(
        new Set(this.filteredInstitutes.map((inst) => inst.id))
      ).map((id) => this.Institute.find((inst) => inst.id === id));
    },

    updateSelectedIds() {
      
      const notSelectedIds = this.filteredInstitutes
      .filter(item => !this.selectedIds.includes(item.id))
      .map(item => item.id);

      this.deSelctedIds = notSelectedIds
        
      this.previouslySelectedIds = [...new Set([...this.previouslySelectedIds, ...this.selectedIds])];
    },
    formatDate(dateString) {
      if (!dateString) return ""; 
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },

     selectWhiteLabeled() {
      if (this.whiteLabeledChecked) {
        const whiteLabeledItems = this.items.filter(Institute => Institute.is_white_labeled);
        this.selectedItems = [...new Set([...this.selectedItems, ...whiteLabeledItems])];
      } else {
        this.selectedItems = this.selectedItems.filter(Institute => !Institute.is_white_labeled);
      }
    },
      selectNotWhiteLabeled() {
        if (this.notWhiteLabeledChecked) {
          this.selectedItems = [...new Set([...this.selectedItems, ...this.items])];
        } else {
          this.selectedItems = this.selectedItems.filter(Institute => Institute.is_white_labeled);
        }
    },
    isExpired(expiryDate) {    
    if (!this.omrUploadDate) return false; 
    
    const selectedDate = new Date(this.omrUploadDate).getTime();
    const instituteExpiry = new Date(expiryDate).getTime(); 

    return instituteExpiry <= selectedDate; // Return true if expired
  },
    disableClick(name){
      this[`disable${name}`]= true;
      setTimeout(() => {
        this[`disable${name}`]= false;
      }, 500);
    },

    computedDateFormattedMomentjs(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
    allowedDates(val) {
      return this.allowed_end_date > val;
    },
    
    validate() {
      let valid = true;

      let startDateTime = moment(`${this.unlockDate} ${this.unlockTime}`);
      let endDateTime = moment(`${this.scheduleClose} ${this.scheduleCloseTime}`);
      let scheduleStartDateTime = moment(`${this.startDate} ${this.scheduleCloseTime}`);
      let OmrUploadDateTime = moment(`${this.omrUploadDate} ${this.omrUploadTime}`);
      //changes for issue of schedule end date and time
      let maxEndDate = moment(`${this.startDate} ${this.startTime}`).add(
        2,
        "day"
      );


      let currentTime = moment();
      let minUnlockTime = moment().add(15, "minutes");


      if (!this.testName || this.testName.trim().length == 0) {
        this.$toasted.error(`Please enter test name`, { icon: "info" });
        valid = false;
      } 
      else if (!startDateTime.isValid()) {
        this.$toasted.error(`Please select unlock date and time`, { icon: "info" });
        valid = false;
      } else if (!endDateTime.isValid()) {
        this.$toasted.error(`Please select schedule start date and time`, { icon: "info" });
        valid = false;
      }  
      else if (!scheduleStartDateTime.isValid()) {
        this.$toasted.error(`Please select schedule close date and time`, { icon: "info" });
        valid = false;
      }
      else if (!OmrUploadDateTime.isValid()) {
        this.$toasted.error(`Please select OMR upload date and time`, { icon: "info" });
        valid = false;
      }  
      else if (startDateTime.isBefore(minUnlockTime)) {
        this.$toasted.error(`Unlock time should be at least 15 minutes greater than the current time`, { icon: "info" });
        valid = false;
      } 
      //changes for issue of schedule end date and time
      else if (((!this.longTimeTest && scheduleStartDateTime.isAfter(maxEndDate))||(this.longTimeTest && !scheduleStartDateTime.isAfter(maxEndDate)))) {
        this.$toasted.error(
          `Schedule end cannot be ${this.longTimeTest ? "less" : "greater"} than ${maxEndDate.format(
            "DD/MM/YYYY HH:mm"
          )}`,
          { icon: "info" }
        );
        valid = false;
      }else if (this.expiredInstitutesIds.some(expired => this.selectedIds.includes(expired.id))) {
        this.$toasted.error(
          `Subscription of the following institutes expire before test completion please deselect them.`,
          { icon: "info" }
        );
        valid = false;
      }
      else 
      return valid;
    },
    shareTest() {
      let unlockDateTime = moment(`${this.unlockDate} ${this.unlockTime}`).format('YYYY-MM-DD HH:mm:ss');
      let scheduleStartDateTime = moment(`${this.startDate} ${this.scheduleTime}`).format('YYYY-MM-DD HH:mm:ss');
      let scheduleCloseDateTime = moment(`${this.scheduleClose} ${this.scheduleCloseTime}`).format('YYYY-MM-DD HH:mm:ss');
      let omrUploadDateTime = moment(`${this.omrUploadDate} ${this.omrUploadTime}`).format('YYYY-MM-DD HH:mm:ss');

      let reqData = {
        test_id: this.data.selectedTest.id,
        institute_ids: this.selectedIds,
        publish_time : unlockDateTime || null,
        start_time: scheduleStartDateTime || null,
        end_time: scheduleCloseDateTime || null,
        omr_upload_time: omrUploadDateTime || null,

      };

      if (!this.validate(this.totalSelected > 0 ? false : true)) {
        return;
      }

      this.share(reqData)
        .then((response) => {
          this.onClose({ status: false, reloadTest: true , getList: true });
          this.$toasted.success(`Test shared successfully.`, { icon: "check_circle" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  computed: {
    totalSelected() {
      return this.selectedIds ? this .selectedIds.length : 0;
    },
    institutesToDisplay() {    
      return this.filteredInstitutes.length > 0 ? this.filteredInstitutes : this.Institute;
    },
    ...mapState("userStore", ["user", "myInstitute"]),
  },
  
  watch: {
    status(val) {
      if (val) {
        this.resetValues();
        if (this.isRescheduling) {
          this.cloneScheduleData();
        }
      }
    },
},
};
</script>

<style lang="scss" scoped>
.start-date-disable {
  pointer-events: none;
}


tr td{
  & div.v-input {
    margin: 0; 
    &  :where(div.v-messages){
    display: none;
  }
  } 
}


thead.v-data-table-header {
  display: none;
}

.Schedule-right {
  overflow-y: auto;
  height: 75dvh;
}

.share {
  .info-row {
    .v-text-field {
      padding-top: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }
  .Schedule-block .date-row-share .info-row {
    flex-wrap: wrap;
    .label-data {
      width: 100%;
    }
    .hr-min-block {
      width: 40%;
      padding:0.75rem 0 0 0;
    }
    .date-pick {
      width: 40%;
      padding:0.75rem 0 0 0;
    }
  }
}
.intitude-header {
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}
.select-intitude-share {
  width: 100%;
}
</style>

<style>
.select-intitude-share .v-select__selections {
  min-height: 46px !important;
  padding-top: 0px !important;
}
.select-intitude-share .v-input__slot {
  min-height: 40px !important;
  padding-top: 0px !important;
}
.select-intitude-share .v-input__append-inner {
  margin-top: 12px;
}
</style>


<style lang="scss" scoped>
@media (max-width: 991px) {
  .share{
  ::v-deep .v-data-table {
    max-width: 100% !important;
    
    table {
      width: 100% !important;
      min-width: 100% !important; 
    }
  }
}
}
</style>